var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13137,1.13137,-1.13137,1.13137,20,-2.62742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.406,10.625L9.375,10.625L9.375,13.594C9.375,13.68 9.445,13.75 9.531,13.75L10.469,13.75C10.555,13.75 10.625,13.68 10.625,13.594L10.625,10.625L13.594,10.625C13.68,10.625 13.75,10.555 13.75,10.469L13.75,9.531C13.75,9.445 13.68,9.375 13.594,9.375L10.625,9.375L10.625,6.406C10.625,6.32 10.555,6.25 10.469,6.25L9.531,6.25C9.445,6.25 9.375,6.32 9.375,6.406L9.375,9.375L6.406,9.375C6.32,9.375 6.25,9.445 6.25,9.531L6.25,10.469C6.25,10.555 6.32,10.625 6.406,10.625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.06725f7d0a5009a3136324d8cbb561ad.svg";
export { ForwardRef as ReactComponent };